import { render, staticRenderFns } from "./PosReceivableOutbox.vue?vue&type=template&id=4d4fa5a0"
import script from "./PosReceivableOutbox.vue?vue&type=script&lang=js"
export * from "./PosReceivableOutbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports